import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { EventUser } from '../models/eventUser.model';
import { attendance } from '../models/attendance.model';
import { member } from '../models/member.model';
import { primarySelection } from '../models/primary-selection.model';
import { GetNameMember } from '../models/get-name-member.model';
import { ChartElement } from '../models/chart-element.model';

@Injectable({ providedIn: 'root' })
export class MemberService {
  apiHost: string = environment.apiHost;
  isLoading: boolean = true;

  constructor(private http: HttpClient) {}

  getMember(memberId: number): Promise<member> {
    let promise = new Promise<member>((resolve, reject) => {
      return this.http
        .get<member>(
          this.apiHost + '/Member/GetMemberById?Id=' + memberId.toString()
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }

  getMemberFromAccount(accountId: string): Promise<member> {
    let promise = new Promise<member>((resolve, reject) => {
      return this.http
        .get<member>(
          this.apiHost + '/Member/GetMemberByAccountId?AccountId=' + accountId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }  

  getPrimarySelection(memberId: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .get<any>(
          this.apiHost +
            '/Member/GetPrimarySelection?MemberId=' +
            memberId.toString()
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }

  setPrimarySelection(memberId: number, userId: string): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost +
            '/Member/SetPrimarySelection?MemberId=' +
            memberId.toString() +
            '&UserId=' +
            userId,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }

  getAssignees(userId: string): Promise<GetNameMember[]> {
    let promise = new Promise<GetNameMember[]>((resolve, reject) => {
      return this.http
        .get<GetNameMember[]>(
          this.apiHost + '/Member/GetAssignees?UserId=' + userId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }

  getEventOrganizers(): Promise<GetNameMember[]> {
    let promise = new Promise<GetNameMember[]>((resolve, reject) => {
      return this.http
        .get<GetNameMember[]>(
          this.apiHost + '/Permission/getEventOrganizers'
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }

  getGroupAdmins(): Promise<GetNameMember[]> {
    let promise = new Promise<GetNameMember[]>((resolve, reject) => {
      return this.http
        .get<GetNameMember[]>(
          this.apiHost + '/Permission/getGroupAdmins'
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }

  getLeaders(groupId: number): Promise<number[]> {
    let promise = new Promise<number[]>((resolve, reject) => {
      return this.http
        .get<number[]>(this.apiHost + '/Member/GetLeaders?GroupId=' + groupId)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }

  getMemberLocations(memberIds: number[]): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Member/GetMemberLocations', memberIds)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }

  getAgeBarChartByMembers(memberIds: number[]): Promise<ChartElement[]> {
    let promise = new Promise<ChartElement[]>((resolve, reject) => {
      return this.http
        .post<ChartElement[]>(
          this.apiHost + '/Member/getAgeBarChartByMembers', memberIds
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            resolve(msg);
          }
        );
    });  
    return promise;
  }
  getAgePieChartByMembers(memberIds: number[]): Promise<ChartElement[]> {
    let promise = new Promise<ChartElement[]>((resolve, reject) => {
      return this.http
        .post<ChartElement[]>(
          this.apiHost + '/Member/getAgePieChartByMembers', memberIds
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }

  getEducationalPieChartByMembers(memberIds: number[]): Promise<ChartElement[]> {
    let promise = new Promise<ChartElement[]>((resolve, reject) => {
      return this.http
        .post<ChartElement[]>(
          this.apiHost + '/Member/getEducationalPieChartByMembers', memberIds
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }

  getGradeBarChartByMembers(memberIds: number[]): Promise<ChartElement[]> {
    let promise = new Promise<ChartElement[]>((resolve, reject) => {
      return this.http
        .post<ChartElement[]>(
          this.apiHost + '/Member/getGradeBarChartByMembers', memberIds
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }
  
  getGenderPieChartByMembers(memberIds: number[]): Promise<ChartElement[]> {
    let promise = new Promise<ChartElement[]>((resolve, reject) => {
      return this.http
        .post<ChartElement[]>(
          this.apiHost + '/Member/getGenderPieChartByMembers', memberIds
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);  
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }

  getStatusPieChartByMembers(memberIds: number[]): Promise<ChartElement[]> {
    let promise = new Promise<ChartElement[]>((resolve, reject) => {
      return this.http
        .post<ChartElement[]>(
          this.apiHost + '/Member/getStatusPieChartByMembers', memberIds
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);  
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }
    
  getCityBarChartByMembers(memberIds: number[]): Promise<ChartElement[]> {
    let promise = new Promise<ChartElement[]>((resolve, reject) => {
      return this.http
        .post<ChartElement[]>(
          this.apiHost + '/Member/getCityBarChartByMembers', memberIds
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);  
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  } 

  getStateBarChartByMembers(memberIds: number[]): Promise<ChartElement[]> {
    let promise = new Promise<ChartElement[]>((resolve, reject) => {
      return this.http
        .post<ChartElement[]>(
          this.apiHost + '/Member/getStateBarChartByMembers', memberIds
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);  
          },
          (msg) => {  
            resolve(msg);
          }
        );
    });
    return promise;
  }

  getMembershipPieChartByMembers(memberIds: number[]): Promise<ChartElement[]> {
    let promise = new Promise<ChartElement[]>((resolve, reject) => {
      return this.http
        .post<ChartElement[]>(
          this.apiHost + '/Member/getMembershipPieChartByMembers', memberIds
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);  
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }

  deleteGuests(memberIds: number[]): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost + '/Member/deleteGuests', memberIds
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);  
          },
          (msg) => {
            resolve(msg);
          }
        );
    });
    return promise;
  }  
 
  getOffset(memberId: number): Promise<number> {
    let promise = new Promise<number>((resolve, reject) => {
      return this.http
        .get<number>(
          this.apiHost + '/Member/getOffset?MemberId=' + memberId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['offset']);  
          },
          (msg) => {  
            resolve(msg);
          }
        );
    });
    return promise;
  }

  saveOffset(memberId: number, offset: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost + '/Member/saveOffset?MemberId=' + memberId +'&Offset=' + offset, null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);  
          },
          (msg) => {  
            resolve(msg);
          }
        );
    });
    return promise;
  }

  generateAccountsAndRelations() {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost + '/Member/GenerateAccountsAndRelations', null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);  
          },
          (msg) => {  
            resolve(msg);
          }
        );
    });
    return promise;
  }

}
